module.exports = __webpack_public_path__ + "db5a5be210a73d396195dc37d67921fc.svg";